import { render, staticRenderFns } from "./WelcomeNavbar.vue?vue&type=template&id=64384ef2"
import script from "./WelcomeNavbar.vue?vue&type=script&lang=js"
export * from "./WelcomeNavbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports